import React, { useCallback, useEffect, useState } from "react";
import { Button } from "reactstrap";
import { useTranslate } from "react-translate";

const ScrollButton = ({ minScroll, condition }) => {

    const t = useTranslate('laboratory-detail');

    //Control button visibility
    const [visible, setVisible] = useState(false);

    //Cache response
    const onScroll = useCallback(() => {
        const fullPage = document.getElementById("full-page");
        const scrollMet = (condition && Math.floor(fullPage.scrollTop) >= minScroll);

        //Only save scroll condition if it changed, else, stay the same
        setVisible(prev => (
            prev !==  scrollMet
            ? scrollMet 
            : prev
        ));

    }, [visible, condition]);

    useEffect(() => {
        document.getElementById("full-page").addEventListener("scroll", onScroll);

        return () => {
            document.getElementById("full-page").removeEventListener("scroll", onScroll);
        }
    }, [onScroll]);
    
    return (
        <div className={`scroll-fixed-button ${
            (!visible) 
            ? "button-disabled" 
            : ""
            }`}>
            <Button color="secondary"
                onClick={() => {
                    document.getElementById("full-page").scrollTop = 0;
                }}>
                <div className="d-flex" style={{gap: "3px"}}> 
                    <i className="icon-top" style={{fontSize: "16px"}}></i> 
                    <div>{t("fixed-scroll-button")}</div>
                </div>
            </Button>
        </div>
    )
}

export default ScrollButton;